<footer class="bg-primary text-white w-full py-12 px-6 md:px-10 shadow-lg">
    <!-- Main Footer Content -->
    <div class="max-w-7xl mx-auto">
        <!-- Top Section with Logo and Contact -->
        <div class="flex flex-col md:flex-row justify-between mb-10 pb-8 border-b border-white/20">
            <!-- Logo Section -->
            <div class="flex flex-col items-center md:items-start mb-8 md:mb-0 ">
                <img class="h-16 w-auto mb-4 cursor-pointer" routerLink="/"
                    src="https://images.mashhoorplus.in/file/17445388814070199A2F5-E4E9-41A2-A62B-D2A356418AA9.png"
                    alt="Mashhoor Plus Logo">
                <div class="text-center md:text-left">
                    <p class="text-lg font-semibold mb-1">Mashhoor Plus Pharmaceuticals</p>
                    <p>227, Rajvansh Vihar Garh Road,</p>
                    <p>Meerut, Uttar Pradesh, 250004</p>
                </div>
            </div>

            <!-- Contact Section -->
            <div class="flex flex-col">
                <div class="flex items-center mb-4">
                    <i class="pi pi-phone text-2xl mr-3"></i>
                    <p class="text-xl font-semibold">CONTACT US</p>
                </div>
                <div class="space-y-2">
                    <div class="flex flex-col md:flex-row md:items-center">
                        <span class="font-medium mr-2">Phone:</span>
                        <span>+91  82733 63610, +91 82733 63910</span>
                    </div>
                    <div class="flex flex-col md:flex-row md:items-center">
                        <span class="font-medium mr-2">Email:</span>
                        <span>mashhoorplus&#64;gmail.com</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Middle Section - Links -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <!-- Our Expertise -->
            <div>
                <h3 class="text-lg font-semibold mb-4 pb-2 border-b border-white/20">Shop</h3>
                <ul class="space-y-2">
                    <li *ngFor="let data of shopCategories"><a (click)="redirectToProduct(data.id)"
                            class="hover:underline transition-all cursor-pointer">{{data.name}}</a></li>

                </ul>
            </div>

            <!-- About Us -->
            <div>
                <h3 class="text-lg font-semibold mb-4 pb-2 border-b border-white/20">About Us</h3>
                <ul class="space-y-2">
                    <li><a [routerLink]="'/about-us'" class="hover:underline transition-all">Story</a></li>
                    <li><a [routerLink]="'/blogs'" class="hover:underline transition-all">Blogs</a></li>
                    <!-- <li><a [routerLink]="'/products/1'" class="hover:underline transition-all">In news</a></li> -->
                    <!-- <li><a [routerLink]="'/products/1'" class="hover:underline transition-all">Ingredients</a></li> -->
                </ul>
            </div>

            <!-- Our Policies -->
            <div>
                <h3 class="text-lg font-semibold mb-4 pb-2 border-b border-white/20">Our Policies</h3>
                <ul class="space-y-2">
                    <li><a [routerLink]="'/privacy-policy'" class="hover:underline transition-all">Privacy
                            Policy</a>
                    </li>
                    <li><a [routerLink]="'/return-policy'" class="hover:underline transition-all">Return & Refund
                            Policy</a></li>
                    <!-- <li><a [routerLink]="'/shipping-policy'" class="hover:underline transition-all">Shipping Policy</a></li> -->
                    <li><a [routerLink]="'/terms-service'" class="hover:underline transition-all">Terms Of
                            Service</a>
                    </li>
                </ul>
            </div>

            <!-- Find Us -->
            <div>
                <h3 class="text-lg font-semibold mb-4 pb-2 border-b border-white/20">Connect With Us</h3>
                <div class="mb-6">
                    <p class="mb-3 text-sm">Found us on:</p>
                    <div class="flex flex-wrap gap-4">
                        <ng-container *ngFor="let data of partners">
                            <a [href]="data.url" class="bg-white/10 p-2 rounded-md hover:bg-white/20 transition-all">
                                <img class="h-8 w-auto" [src]="data.logo" alt="">
                            </a>
                        </ng-container>
                    </div>
                </div>
                <div>
                    <p class="mb-3 text-sm">Social media:</p>
                    <div class="flex flex-wrap gap-4">
                        <ng-container *ngFor="let data of social">
                            <a [href]="data.url" class="bg-white/10 p-2 rounded-md hover:bg-white/20 transition-all">
                                <img class="h-8 w-auto" [src]="data.logo" alt="">
                            </a>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <!-- Copyright -->
        <div class="text-center pt-6 border-t border-white/20">
            <p>&copy; {{2025}} Mashhoor Plus Pharmaceuticals. All rights reserved.</p>
        </div>
    </div>
</footer>